import React, { useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";
import { connect, useSelector } from "react-redux";
import pwd from "../assets/images/health4.png";
import { storeResetPasswordAction } from "../redux/action/recoverPasswordAction";

function ResetPassword({ storeResetPasswordAction }) {
  const { enqueueSnackbar } = useSnackbar();
  const loader = useSelector(state => state.recoverPassword.resetPassword_loader)
  const [state, setState] = useState({
    newPassword: "",
    confirm_password: "",
  });

  const { newPassword, confirm_password } = state;

  let { id, token } = useParams(); // Id and Token destructured to get the id and token from the route params
  const history = useHistory();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState({
      ...state,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(state)
    try {
      storeResetPasswordAction(id, token, state).then((res) => {
        if (res.status) {
          enqueueSnackbar(res?.message || "Password reset successful", {
            variant: "success",
            vertical: "top",
            horizontal: "right",
          });
          setTimeout(() => {
            history.push('/login-pharmacy')
          }, 1500)
        } else {
          enqueueSnackbar(res?.message || "OOps, Something went wrong", {
            variant: "error",
            vertical: "top",
            horizontal: "right",
          });
        }
      });
    } catch (err) {
      enqueueSnackbar("Unexpected Error", {
        variant: "error",
        vertical: "top",
        horizontal: "right",
      });
    }
  };

  return (
    <div className="pwdreset">
      <div>
        <img src={pwd} alt="healthify-logo" />
      </div>
      <div>
        <h1>Reset Password</h1>
        <p>Please enter your new password</p>
      </div>
      <form onSubmit={handleSubmit}>
        <input
          type="password"
          placeholder="Enter Password"
          onChange={handleChange}
          name="newPassword"
          value={newPassword}
          required
          autoComplete="true"
        />
        <br />
        <input
          type="password"
          placeholder="Confirm Password"
          onChange={handleChange}
          name="confirm_password"
          value={confirm_password}
          required
          autoComplete="true"
        />
        <br />
        <button disabled={loader}>
          {
            loader ? 'RESETTING ...' : 'RESET'
          }
          </button>
      </form>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    storeResetPasswordAction: (id, token, payload) => dispatch(storeResetPasswordAction(id, token, payload)),
  };
};
export default connect(null, mapDispatchToProps)(ResetPassword);
